import { render } from "./CloverResultPopup.vue?vue&type=template&id=5ac80181&scoped=true"
import script from "./CloverResultPopup.vue?vue&type=script&lang=js"
export * from "./CloverResultPopup.vue?vue&type=script&lang=js"

import "./CloverResultPopup.vue?vue&type=style&index=0&id=5ac80181&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac80181"]])

export default __exports__